import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { Route, BrowserRouter as Router } from 'react-router-dom';
import App, { APP_ROOT_PATH } from './App';
import * as serviceWorker from './serviceWorker';

const routing = (
  <Router>
    <Route exact path={APP_ROOT_PATH} component={App} />
    <Route path={`${APP_ROOT_PATH}/:language`} component={App} />
  </Router>
);

ReactDOM.render(routing, document.getElementById('root'));
// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
